import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ConsentState } from 'features/consent/consentTypes';

const initialState: ConsentState = {
  necessary: true,
  analytics: false,
  marketing: false,
  decided: false,
};

const consentSlice = createSlice({
  name: 'consent',
  initialState,
  reducers: {
    setConsent(state, action: PayloadAction<Omit<ConsentState, 'necessary'>>) {
      state.analytics = action.payload.analytics;
      state.marketing = action.payload.marketing;
      state.decided = true;

      localStorage.setItem('cookie_consent', JSON.stringify(state));
    },
    loadConsent(state) {
      const saved = localStorage.getItem('cookie_consent');
      if (saved) {
        return JSON.parse(saved);
      }
    },
    resetConsent(state) {
      localStorage.removeItem('cookie_consent');
      return initialState;
    },
  },
});

export const { setConsent, loadConsent, resetConsent } = consentSlice.actions;
export default consentSlice.reducer;